<script>
import DatePicker from '@/components/inputs/DatePicker'
import VTimePicker from 'vuetify/es5/components/VTimePicker/VTimePicker'

export default {
    name: 'TimePicker',
    extends: DatePicker,
    props: {
        type: {
            type: String,
            default: 'time'
        },
        nudgeRight: {
            type: Number,
            default: 60
        }
    },
    data: () => ({
        timePickerInstance: null
    }),
    watch: {
        isMenuActive (val) {
            if (val && this.timePickerInstance) {
                //  Ogni volta che riapro il menu imposto la selezione dell'ora
                this.timePickerInstance.componentInstance.selecting = 1
            }
        }
    },
    methods: {
        genPicker () {
            let _this = this
            let instance = this.$createElement(VTimePicker, {
                props: {
                    locale: this.$utils.getLocale(),
                    headerColor: 'white',
                    format: '24hr',
                    scrollable: true,
                    min: this.min,
                    max: this.max,
                    value: this.internalValue
                },
                on: {
                    input (val) {
                        _this.internalValue = val
                    },
                    'click:minute' (val) {
                        //  Per evitare che si chiudano anche altri menu nel caso l'input sia in un menu
                        setTimeout(() => {
                            _this.isMenuActive = false
                        })
                    }
                },
                nativeOn: {
                    click (e) {
                        _this.pressedTab = false
                    }
                }
            })
            this.timePickerInstance = instance
            return instance
        }
    }
}
</script>
